import type { RichBlock } from '@/components/shared/rich-text.types';

export interface ContactSection {
  readonly title: string;
  readonly blocks: readonly RichBlock[];
}

/**
 * Contact page copy, transcribed verbatim from the client-supplied `09-Contact Page content` document
 * for BFL-1560 ("Create Contact Page UI").
 *
 * This REPLACES the earlier prototype copy (four phone cards and two mailing addresses taken from the
 * approved mockup). Those numbers appear in no client document; BFL-1560 AC-002 states the attached
 * document's content is what the page displays, so they were dropped rather than merged. If Bankers
 * Fidelity still wants them, they come back as a documented addition, not as leftovers.
 *
 * The wording is contractual — do not reword, re-punctuate or "improve" it, including the "Zelis™"
 * trademark sign.
 */

/** BFL-1560 AC-003. The address is displayed exactly as provided. */
export const CLAIMS_MAILING: ContactSection = {
  title: 'Claims Mailing Address',
  blocks: [
    {
      kind: 'paragraph',
      content: [
        'Please address all claims to the following: ',
        { bold: 'PO Box 211701 Eagan, MN 55121' },
      ],
    },
  ],
};

/** BFL-1560 AC-004 to AC-007. */
export const EPAYMENT: ContactSection = {
  title: 'Learn more about our new ePayment vendor, Zelis™',
  blocks: [
    {
      kind: 'paragraph',
      content: [
        'Bankers Fidelity has selected Zelis™ Payments (formerly Pay-Plus Solutions, Inc.) as our ePayment vendor to assist us in expediting payment and remittance transactions, as well as complying with PPACA Section 1104. To sign up for ePayments using ACH or Virtual Payment Cards, as well as electronic remittances (835, Excel, PDF), please visit ',
        { link: 'bankersfidelity.epayment.center', href: 'https://bankersfidelity.epayment.center' },
        '.',
      ],
    },
    { kind: 'subheading', text: 'Zelis Providers' },
    {
      kind: 'list',
      items: [
        ['Email: ', { link: 'csdept@zelispayments.com', href: 'mailto:csdept@zelispayments.com' }],
        ['Phone: ', { link: '877-828-8770', href: 'tel:+18778288770' }],
      ],
    },
    { kind: 'subheading', text: 'ePayment Center Providers' },
    {
      kind: 'list',
      items: [
        ['Email: ', { link: 'help@epayment.center', href: 'mailto:help@epayment.center' }],
        ['Phone: ', { link: '855-774-4392', href: 'tel:+18557744392' }],
      ],
    },
  ],
};

/** BFL-1560 AC-008. */
export const EDI: ContactSection = {
  title: 'Save time and reduce cost by using EDI',
  blocks: [
    {
      kind: 'paragraph',
      content: [
        'Bankers Fidelity now offers Real-Time Eligibility Inquiry and Response 270/271 transactions. For assistance with submitting Real-Time transactions, please contact your Practice Management System Vendor.',
      ],
    },
  ],
};

export const CONTACT_SECTIONS: readonly ContactSection[] = [CLAIMS_MAILING, EPAYMENT, EDI];
